import { makeStyles } from "@material-ui/core/styles";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import ResponsiveTable from "@saleor/components/ResponsiveTable";
import TableCellHeader from "@saleor/components/TableCellHeader";
import { maybe } from "@saleor/misc";
import React from "react";
import { FormattedMessage } from "react-intl";

const useStyles = makeStyles(
  () => ({
    table: {
      "& td": {
        fontSize: "15px"
      },
      "& th": {
        fontSize: "15px"
      },
      tableLayout: "fixed"
    }
  }),
  { name: "PayoutsList" }
);

interface MallOrdersListProps {
  mallOrders: any;
}

const MallOrdersList: React.FC<MallOrdersListProps> = (
  props: MallOrdersListProps
) => {
  const colNum = 2;
  const classes = useStyles({});
  const { mallOrders } = props;
  const data = mallOrders?.mallOrderCount?.data;

  return (
    <>
      <ResponsiveTable className={classes.table}>
        <TableHead>
          <TableCellHeader>
            <FormattedMessage defaultMessage="Mall" />
          </TableCellHeader>
          <TableCellHeader>
            <FormattedMessage defaultMessage="No. of Orders" />
          </TableCellHeader>
        </TableHead>
        <TableBody>
          {maybe(
            () =>
              data?.map((order, idx) => (
                <TableRow key={order ? idx : "skeleton"}>
                  <TableCell>{maybe(() => order?.mall_name)}</TableCell>
                  <TableCell>{maybe(() => order?.order_count)}</TableCell>
                </TableRow>
              )),
            <TableRow>
              <TableCell colSpan={colNum}>
                <FormattedMessage defaultMessage="No mall orders found" />
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </ResponsiveTable>
    </>
  );
};

export default MallOrdersList;
